var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "main-container container-fluid px-0 mx-0" } },
    [
      _c("div", { staticClass: "main-panel mt-0 p-0 m-0" }, [
        _vm.showBreadcrumbFullPage
          ? _c(
              "div",
              { staticClass: "back-button-container row ml-md-5 ml-2" },
              [
                _c("div", { staticClass: "ml-xl-4 ml-md-3 ml-lg-3 ml-3" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "pl-xl-0 pl-2 ml-md-3 mt-md-5 mt-3 bring-button-to-front",
                      on: { click: _vm.redirectToDefaultBrowse }
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: ["fas", "arrow-left"] }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.contentPageNavigationText))
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "rel-container" },
          [
            _vm.contentPageModel.id
              ? _c("froalaView", {
                  model: {
                    value: _vm.contentPageModel.content,
                    callback: function($$v) {
                      _vm.$set(_vm.contentPageModel, "content", $$v)
                    },
                    expression: "contentPageModel.content"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-356da3ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-356da3ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewOfferingPage.vue
// module id = null
// module chunks = 